import { CentralizerContextFactory } from '../edit/CentralizerContextFactory';
import { Livestream } from '../../../functions/src/types/firestore/User/Livestream';

export const LivestreamCentralizerContext =
  CentralizerContextFactory.buildFirestoreDocument<Livestream>();
